import { useState } from "react";

import {
  Text,
  TwSelector as Selector,
  Textarea,
  HelperText,
  Checkbox,
} from "@virkesborsen/ui-component-library";
import { useDrone } from "../../../context/DroneContext";

export default function ObstacleInfo() {
  const { extraData, setExtraData, errorMessages, setErrorMessages } =
    useDrone();
  const [hasObstacles, setHasObstacles] = useState(extraData?.hasObstacles);

  const handleSelect = (option) => {
    setHasObstacles(option.value);
    setExtraData((prev) => ({ ...prev, hasObstacles: option.value }));
    setErrorMessages((prev) => ({ ...prev, obstacleInfo: undefined }));
  };

  const handleTermsChange = ({ name, value }) => {
    setErrorMessages((prev) => ({ ...prev, [name]: undefined }));
    setExtraData((prev) => ({ ...prev, [name]: value }));
  };

  const options = [
    {
      label: "Nej",
      value: false,
    },
    {
      label: "Ja",
      value: true,
    },
  ];

  return (
    <div className="flex flex-col w-full gap-4">
      <div className="flex flex-col gap-2">
        <Text variant="subheaderSmallMedium">
          Hjälp piloten planera flygningen
        </Text>
        <Text variant="bodySmallRegular" className="text-pebble-500">
          Ange om det finns hinder som bommar eller svårtillgängliga vägar. Alla
          fält är obligatoriska.
        </Text>
      </div>

      <div className="w-full h-[0.5px] border border-stone-500/17" />

      <div className="flex flex-col gap-2 pt-2 px-4">
        <Text variant="labelLargeMedium">
          Finns det några hinder för piloten?
        </Text>
        <Text variant="bodySmallRegular" className="text-pebble-500">
          T.ex. vägbommar, grindar eller svårframkomlig väg.
        </Text>
      </div>
      <div className="w-full flex flex-col gap-1-5">
        <Selector>
          {options.map((option) => (
            <Selector.Option
              key={option.ref}
              label={option.label}
              value={option.value}
              isSelected={hasObstacles === option.value}
              onClick={handleSelect}
            />
          ))}
        </Selector>

        <HelperText
          icon="ExclamationFilled"
          label={errorMessages.obstacleInfo}
          className={`text-danger-500 fill-danger-500 pl-4 
            ${errorMessages.obstacleInfo ? "opacity-100" : "opacity-0"}   
            `}
        />
      </div>
      {hasObstacles && (
        <>
          <div className="flex flex-col gap-2 pt-2 px-4">
            <Text variant="labelLargeMedium">
              Hur kan piloten passera hindret?
            </Text>
            <Text variant="bodySmallRegular" className="text-pebble-500">
              Ange t.ex. kod till bom, kontaktperson eller annan instruktion som
              hjälper piloten att passera.
            </Text>
          </div>
          <div>
            <Textarea
              tw
              name="issueDescription"
              onChange={(value) =>
                handleTermsChange({ name: "obstacleDescription", value })
              }
              placeholder="Lägg till kod, kontaktupgift eller alternativ väg"
              value=""
            />
          </div>
        </>
      )}

      <div className="w-full h-[0.5px] border border-stone-500/17" />

      <div className="flex flex-col gap-4">
        <Text variant="labelLargeMedium" className="pt-2 px-4">
          Bekräfta innan du går vidare
        </Text>
        <div className="flex flex-col gap-1">
          <div className="flex flex-col gap-1-5">
            <div className="flex flex-col gap-2 p-4 bg-white-50 rounded-lg-alt">
              <Checkbox
                onClick={(value) =>
                  handleTermsChange({ name: "ownershipTerms", value })
                }
                checked={extraData?.ownershipTerms}
              >
                <Text variant="labelMediumRegular">
                  Jag äger fastigheten eller har tillåtelse från
                  fastighetsägaren att beställa tjänsten
                </Text>
              </Checkbox>
            </div>
            <HelperText
              icon="ExclamationFilled"
              label={errorMessages.ownershipTerms}
              className={`text-danger-500 fill-danger-500 pl-4 pb-2 
            ${errorMessages.ownershipTerms ? "opacity-100" : "opacity-0"}   
            `}
            />
          </div>

          <div className="flex flex-col gap-1-5">
            <div className="flex flex-col gap-2 p-4 bg-white-50 rounded-lg-alt">
              <Checkbox
                onClick={(value) =>
                  handleTermsChange({ name: "locationTerms", value })
                }
                checked={extraData?.locationTerms}
              >
                <Text variant="labelMediumRegular">
                  Min fastighet ligger inte på en ö eller på militärt område
                </Text>
              </Checkbox>
            </div>
            <HelperText
              icon="ExclamationFilled"
              label={errorMessages.locationTerms}
              className={`text-danger-500 fill-danger-500 pl-4 pb-2 
            ${errorMessages.locationTerms ? "opacity-100" : "opacity-0"}   
            `}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
